import { createFileRoute } from '@tanstack/react-router';

import { validateRouteRole } from '@/lib/routing';
import { coachCalendarSearchSchema } from '@/lib/my-classes-utils';
import { isCoach } from '@airreading/common';

import { CoachClassesCalendar } from './-components/coach-classes-calendar';

export const Route = createFileRoute('/_layout/my-classes/calendar')({
  beforeLoad: validateRouteRole(isCoach),
  component: MyClassesCalendar,
  validateSearch: coachCalendarSearchSchema,
});

function MyClassesCalendar() {
  return <CoachClassesCalendar route={Route} />;
}
